export function requiredNumberField(
  error = "errors.ruleIsRequiredAndNotEmpty",
) {
  return $ck.z.number({
    required_error: error,
  });
}

export function optionalNumberField() {
  return $ck.z.number().optional();
}

export function requiredStringField(
  error = "errors.ruleIsRequiredAndNotEmpty",
) {
  return (
    $ck.z
      .string({
        required_error: error,
      })
      //.trim()
      .min(1, error)
  );
}

/**
 * Validate a string is required in DB but allow empty string
 */
export function stringOrEmptyField() {
  return $ck.z.string().transform((val) => val || "");
}

export function requiredStringDate(error = "errors.ruleIsRequiredAndNotEmpty") {
  return (
    $ck.z
      .string({
        required_error: error,
      })
      //.trim()
      .refine((val) => val?.length, {
        message: error,
      })
      .refine((val) => !isNaN(Date.parse(val)), {
        message: "errors.ruleIsDate",
      })
  );
}

export function stringDateOrNullField() {
  return $ck.z.coerce
    .string()
    .datetime({ local: true })
    .nullish()
    .refine((val) => !val || !isNaN(Date.parse(val)), {
      message: "errors.ruleIsDate",
    })
    .transform((val) => val || null);
}

export function booleanField() {
  return $ck.z
    .boolean({
      invalid_type_error: "errors.selectSomeValue",
    })
    .transform((val) => val || false);
}

export function requiredNumericListItemField(
  message: string = "errors.itemNotFoundInList",
) {
  return $ck.z.number({
    errorMap: () => ({ message }),
  });
}

export function requiredStringListItemField(
  message: string = "errors.itemNotFoundInList",
) {
  return $ck.z
    .string({
      errorMap: () => ({ message }),
    })
    .min(1, message);
}

export function stringOrEmptyListItemField(
  message: string = "errors.itemNotFoundInList",
) {
  return $ck.z
    .string({
      errorMap: () => ({ message }),
    })
    .transform((val) => val || "");
}
